/* eslint-disable no-shadow */
import { useState } from 'react';
import * as Yup from 'yup';
// import { Link as RouterLink } from 'react-router-dom';
// form
import { useForm } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
// @mui
import { Stack, Alert, IconButton, InputAdornment } from '@mui/material';
import { LoadingButton } from '@mui/lab';
// graphQL
import { useLazyQuery } from '@apollo/client';

// routes
// import { PATH_AUTH } from '../../routes/paths';
// auth
import { useAuthContext } from '../../../auth/useAuthContext';
// components
import Iconify from '../../../components/iconify';
import FormProvider, { RHFTextField } from '../../../components/hook-form';
import { INTRANET_USER_LOGIN } from '../../../graphQL/queries';

// ----------------------------------------------------------------------

export default function AuthLoginForm() {
  const { login } = useAuthContext();
  const [clientLogin, { loading }] = useLazyQuery(INTRANET_USER_LOGIN);
  const [showPassword, setShowPassword] = useState(false);

  const LoginSchema = Yup.object().shape({
    email: Yup.string()
      .required('Email è richiesta')
      .email('Email deve essere un indirizzo valido'),
    password: Yup.string().required('Password è richiesta'),
  });

  const defaultValues = {
    email: '',
    password: '',
  };

  const methods = useForm({
    resolver: yupResolver(LoginSchema),
    defaultValues,
  });

  const {
    reset,
    setError,
    handleSubmit,
    formState: { errors, isSubmitting, isSubmitSuccessful },
  } = methods;

  const onSubmit = async (data) => {
    try {
      const { data: responseData, error: queryErrors } = await clientLogin({
        variables: {
          email: data.email,
          password: data.password,
        },
        fetchPolicy: 'no-cache',
      });

      if (queryErrors) {
        setError('afterSubmit', {
          message: queryErrors?.message,
        });
        return;
      }
      const token = responseData?.intranetLogin?.token;

      if (token) {
        await login(token);
        reset();
      } else {
        setError('afterSubmit', {
          message: 'Accesso fallito, nessun token ricevuto.',
        });
        reset();
      }
    } catch (error) {
      console.error(error);
      setError('afterSubmit', {
        message: error.message || 'Si è verificato un errore sconosciuto.',
      });
      reset();
    }
  };

  return (
    <FormProvider methods={methods} onSubmit={handleSubmit(onSubmit)}>
      <Stack spacing={3}>
        {!!errors.afterSubmit && <Alert severity="error">{errors.afterSubmit.message}</Alert>}

        <RHFTextField name="email" label="Indirizzo E-mail" />

        <RHFTextField
          name="password"
          label="Password"
          type={showPassword ? 'text' : 'password'}
          InputProps={{
            endAdornment: (
              <InputAdornment position="end">
                <IconButton onClick={() => setShowPassword(!showPassword)} edge="end">
                  <Iconify icon={showPassword ? 'eva:eye-fill' : 'eva:eye-off-fill'} />
                </IconButton>
              </InputAdornment>
            ),
          }}
        />
      </Stack>

      {/* <Stack alignItems="flex-end" sx={{ }}>
          <Link
          component={RouterLink}
          to={PATH_AUTH.resetPassword}
          variant="body2"
          color="inherit"
          underline="always"
        >
          Password dimenticata?
        </Link> 
      </Stack> */}

      <LoadingButton
        fullWidth
        color="inherit"
        size="large"
        type="submit"
        variant="contained"
        loading={isSubmitSuccessful || isSubmitting || loading}
        sx={{
          my: 3,
          bgcolor: 'text.primary',
          color: (theme) => (theme.palette.mode === 'light' ? 'common.white' : 'grey.800'),
          '&:hover': {
            bgcolor: 'text.primary',
            color: (theme) => (theme.palette.mode === 'light' ? 'common.white' : 'grey.800'),
          },
        }}
      >
        Accedi
      </LoadingButton>
    </FormProvider>
  );
}
